import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators} from '@angular/forms';
import { UserModel } from 'src/app/components/security/users/models/userModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';

@Component({
  selector: 'app-users-addedit',
  templateUrl: './addedituser.component.html'
})
export class AddEditUsersComponent {
    submitted: boolean = false;
    user: UserModel = new UserModel();
    isPasswordVisible: boolean = true;
    username = new FormControl('', [Validators.required]);
    password = new FormControl('', [Validators.required]);
    firstName = new FormControl('', [Validators.required]);
    lastName = new FormControl('', [Validators.required]);
    email = new FormControl('', [Validators.required]);

    constructor(
        public _restAPI: RestAPIService,
        public dialogRef: MatDialogRef<AddEditUsersComponent>,
        @Inject(MAT_DIALOG_DATA) public userData: UserModel) {
            this.user = JSON.parse(JSON.stringify(userData));
            localStorage["applyUserFilterValue"] = 'true';
        }

    async ngOnInit() {
        if (this.user.id) {
            this.username.disable();
            this.isPasswordVisible = false;
        }
    }

    closeDialog(): void {
      this.dialogRef.close(false);
    }

    async saveUser() {
      if(!this.username.invalid && !this.firstName.invalid && !this.lastName.invalid && !this.email.invalid){
          if (this.user.id != null && this.user.id.length > 0) {
              let postData = {
                  id: this.user.id,
                  firstName: this.user.firstName,
                  lastName: this.user.lastName,
                  email: this.user.email
              };

              this._restAPI.put<string>(environment.apiURL + 'api/usermanagement/edit/' + this.user.id, postData).subscribe({
                  next: (results) => {
                      this.dialogRef.close(true);
                  },
                  error: (error) => console.error(error)
              });
          }
          else {
              let postData = {
                userName: this.user.username,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                password: this.user.password,
                email: this.user.email
              };

              this._restAPI.post<string>(environment.apiURL + 'api/usermanagement/add', postData).subscribe({
                  next: (results) => {
                      this.dialogRef.close(true);
                  },
                  error: (error) => console.error(error)
              });
          }
      }
    }
}